import { FunctionRuntime } from '@rossum/api-client/hooks';
import { Box } from '@rossum/ui/material';
import { FormattedMessage } from 'react-intl';
import {
  runtimesConfig,
  runtimeTypesConfig,
} from '../../../../Extension/config';
import styles from '../style.module.sass';

type Props = {
  onClick: () => void;
  runtime: FunctionRuntime;
  selected: boolean;
  dataCy: string;
};

export const RuntimeButton = ({
  onClick,
  runtime,
  selected,
  dataCy,
}: Props) => {
  const { type, translation } = runtimesConfig[runtime];
  const Icon = runtimeTypesConfig[type].icon;

  return (
    <Box
      sx={{
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        backgroundColor: t => (selected ? t.palette.action.hover : undefined),
        border: t =>
          selected
            ? `2px solid ${t.palette.primary.main}`
            : `1px solid ${t.palette.action.hover}`,
        '&:hover': {
          border: t =>
            selected
              ? `2px solid ${t.palette.primary.main}`
              : `1px solid ${t.palette.action.active}`,
        },
      }}
      className={styles.RuntimeButton}
      onClick={onClick}
      data-cy={dataCy}
    >
      <Icon />
      <FormattedMessage id={translation} />
    </Box>
  );
};
